// Simple TR/EN dictionary for Neji'nin Oyun Dünyası.
export const translations = {
  tr: {
    brand: "Neji'nin Oyun Dünyası",
    nav_home: "Ana Sayfa",
    nav_stats: "İstatistikler",
    settings: "Ayarlar",
    language: "Dil",
    sound: "Ses efektleri",
    animations: "Animasyonlar",
    close: "Kapat",
    turkish: "Türkçe",
    english: "İngilizce",

    hero_tagline: "Sayılarla dolu eğlenceli bir dünya",
    hero_desc: "Her gün yeni bulmacalar, sonsuz oyun keyfi. Sayı bloklarını doğru boşluklara yerleştir, zihnini çalıştır ve serini büyüt.",
    featured: "Öne Çıkan Oyun",
    play_now: "Hemen Oyna",
    daily_game: "Günlük Oyun",
    endless_game: "Sonsuz Oyun",
    choose_difficulty: "Zorluk seç",
    more_games: "Daha fazla oyun yolda",
    more_games_desc: "Neji'nin Oyun Dünyası büyümeye devam ediyor. Yeni oyunlar çok yakında!",
    coming_soon: "Yakında",
    view_stats: "İstatistikleri Gör",
    how_to_play: "Nasıl Oynanır?",
    how_1: "Sana verilen sayı bloklarını tahtadaki boşluklara yerleştir.",
    how_2: "Her blok yalnızca doğru uzunluk ve konumdaki boşluğa oturur.",
    how_3: "Kesişen hücrelerdeki rakamlar birbiriyle uyumlu olmalı.",
    how_4: "Tüm bloklar doğru yerleştiğinde bulmacayı çözersin!",

    easy: "Kolay",
    medium: "Orta",
    hard: "Zor",

    back: "Geri",
    hint: "İpucu",
    new_puzzle: "Yeni Bulmaca",
    restart: "Baştan Başla",
    time: "Süre",
    placed: "Yerleşen",
    mode_daily: "Günlük",
    mode_endless: "Sonsuz",
    select_block_hint: "Bir sayı bloğu seç, sonra uygun boşluğa dokun.",
    blocks_tray: "Sayı Blokları",
    all_placed_tray: "Tüm bloklar yerleştirildi 🎉",
    loading: "Bulmaca hazırlanıyor…",
    hint_used_toast: "İpucu kullanıldı",
    no_empty_slots: "Yerleştirilecek boş alan kalmadı",
    wrong_placement: "Buraya olmadı, tekrar dene",

    win_title: "Tebrikler!",
    win_sub: "Bulmacayı tamamladın",
    win_time: "Süre",
    win_hints: "İpucu",
    play_again: "Tekrar Oyna",
    back_home: "Ana Sayfaya Dön",

    stats_title: "İstatistiklerin",
    stats_sub: "İlerlemeni buradan takip et",
    total_completed: "Toplam Tamamlanan",
    daily_completed: "Günlük Tamamlanan",
    endless_completed: "Sonsuz Tamamlanan",
    best_time: "En İyi Süre",
    avg_time: "Ortalama Süre",
    hints_used: "Kullanılan İpucu",
    current_streak: "Güncel Seri",
    longest_streak: "En Uzun Seri",
    days: "gün",
    no_data: "—",
    start_playing: "Oynamaya Başla",
  },
  en: {
    brand: "Neji's Game World",
    nav_home: "Home",
    nav_stats: "Stats",
    settings: "Settings",
    language: "Language",
    sound: "Sound effects",
    animations: "Animations",
    close: "Close",
    turkish: "Turkish",
    english: "English",

    hero_tagline: "A playful world full of numbers",
    hero_desc: "Fresh puzzles every day and endless play. Place the number blocks into the right gaps, train your brain and grow your streak.",
    featured: "Featured Game",
    play_now: "Play Now",
    daily_game: "Daily Game",
    endless_game: "Endless Game",
    choose_difficulty: "Choose difficulty",
    more_games: "More games on the way",
    more_games_desc: "Neji's Game World keeps growing. New games are coming very soon!",
    coming_soon: "Coming soon",
    view_stats: "View Stats",
    how_to_play: "How to play?",
    how_1: "Place the given number blocks into the gaps on the board.",
    how_2: "Each block only fits a gap of the correct length and position.",
    how_3: "Digits in crossing cells must be consistent with each other.",
    how_4: "Solve the puzzle when every block is placed correctly!",

    easy: "Easy",
    medium: "Medium",
    hard: "Hard",

    back: "Back",
    hint: "Hint",
    new_puzzle: "New Puzzle",
    restart: "Restart",
    time: "Time",
    placed: "Placed",
    mode_daily: "Daily",
    mode_endless: "Endless",
    select_block_hint: "Select a number block, then tap a matching gap.",
    blocks_tray: "Number Blocks",
    all_placed_tray: "All blocks placed 🎉",
    loading: "Preparing your puzzle…",
    hint_used_toast: "Hint used",
    no_empty_slots: "No empty gaps left to fill",
    wrong_placement: "Not here, try again",

    win_title: "Congratulations!",
    win_sub: "You solved the puzzle",
    win_time: "Time",
    win_hints: "Hints",
    play_again: "Play Again",
    back_home: "Back to Home",

    stats_title: "Your Stats",
    stats_sub: "Track your progress here",
    total_completed: "Total Completed",
    daily_completed: "Daily Completed",
    endless_completed: "Endless Completed",
    best_time: "Best Time",
    avg_time: "Average Time",
    hints_used: "Hints Used",
    current_streak: "Current Streak",
    longest_streak: "Longest Streak",
    days: "days",
    no_data: "—",
    start_playing: "Start Playing",
  },
};

export const DIFFICULTIES = ["easy", "medium", "hard"];
